export default __webpack_public_path__ + "static/media/omega.d78250c2.png";